module.exports = __webpack_public_path__ + "img/mapa.f924304c.png";